import { Close as CloseIcon } from '@mui/icons-material'
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Typography,
} from '@mui/material'

interface Props {
  open: boolean
  onClose: () => void
}

export const ReviewModal = ({ open, onClose }: Props) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Media Management Review
        <IconButton aria-label="Close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography gutterBottom>
          As part of our ongoing data governance and compliance efforts, please
          review any media that was secured five or more years ago. The purpose
          of this review is to determine whether the information remains current
          and valid.
        </Typography>

        <Typography>For each item reviewed:</Typography>
        <Box component="ul" sx={{ mt: 1, mb: 2, pl: 3 }}>
          <Typography component="li" gutterBottom>
            If the information is still accurate in its present state, verify
            the media to indicate it has been reviewed and approved with correct
            status.
          </Typography>
          <Typography component="li" gutterBottom>
            If the information is no longer current, update its status to
            non-current and mark it as verified.
          </Typography>
          <Typography component="li">
            If the information is no longer needed in EMC, archive the media.
          </Typography>
          <Typography>
            Contact{' '}
            <Link href="mailto:enginesoftware@catsupport.com">
              enginesoftware@catsupport.com
            </Link>{' '}
            if archived media is needed.
          </Typography>
        </Box>

        <Typography>Please note:</Typography>
        <Box component="ul" sx={{ mt: 1, mb: 2, pl: 3 }}>
          <Typography component="li" gutterBottom>
            Non-current media will remain searchable in EMC.
          </Typography>
          <Typography component="li" gutterBottom>
            Archived media will not be searchable or retrievable within EMC.
          </Typography>
        </Box>

        <Typography>
          Ensure all applicable media is reviewed and updated accordingly.
        </Typography>
      </DialogContent>
    </Dialog>
  )
}
